<app-tpl-form
  [title]="('CONTENTS.EDIT.TITLE' | translate) + ' : ' + partner?.key"
  (save)="save()"
  [saveDisabled]="!form.valid || hasNameError() || hasDescriptionError() || hasMediasError() || hasBackgroundError()"
>
  <form [formGroup]="form" *ngIf="partner">
    <mat-form-field class="mat-form-field" appearance="fill">
      <mat-label>{{ 'REFDATA.TYPES' | translate }}</mat-label>
      <mat-select formControlName="type">
        <mat-option [value]="null"></mat-option>
        <mat-option *ngFor="let type of partnerTypes" [value]="type.key">
          {{ type.labelInt }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="row">
      <div style="display: flex; height: 310px; overflow: scroll; width: 355px">
        <app-domain-selector
          formControlName="targetDomains"
          referenceType="partners"
          [referenceKey]="partner.key"
          [referenceByTypeAndKey]="true"
          [includeDefaultDomain]="true"
        ></app-domain-selector>
      </div>
      <mat-card class="form-card space-l-m">
        <mat-card-header class="form-card-header">
          {{ 'REFDATA.PARTNERS.EDIT.MAIN_PICTURE' | translate }}
        </mat-card-header>
        <mat-card-content class="form-card-content">
          <mat-error class="upload-error" *ngIf="hasMediasError()">{{
            'REFDATA.PARTNERS.EDIT.VISIBLE_STATUS_FIELD_REQUIRED' | translate
          }}</mat-error>
          <app-media-upload [width]="150" [height]="200" [singleImage]="true" formControlName="medias"></app-media-upload>
        </mat-card-content>
      </mat-card>

      <mat-card class="form-card space-l-m">
        <mat-card-header class="form-card-header">
          {{ 'REFDATA.PARTNERS.EDIT.BG_PICTURE' | translate }}
        </mat-card-header>
        <mat-card-content class="form-card-content">
          <mat-error class="upload-error" *ngIf="hasBackgroundError()">{{
            'REFDATA.PARTNERS.EDIT.VISIBLE_STATUS_FIELD_REQUIRED' | translate
          }}</mat-error>
          <app-media-upload [width]="150" [height]="200" [singleImage]="true" formControlName="backgroundMedias"></app-media-upload>
        </mat-card-content>
      </mat-card>

      <mat-card class="form-card space-l-m">
        <mat-card-header class="form-card-header">
          {{ 'REFDATA.PARTNERS.EDIT.CROSS_SELLING_PICTURE' | translate }}
        </mat-card-header>
        <mat-card-content class="form-card-content">
          <app-media-upload [width]="150" [height]="200" [singleImage]="true" formControlName="crossSellingMedias"></app-media-upload>
        </mat-card-content>
      </mat-card>

      <mat-card class="form-card space-l-m">
        <mat-card-header class="form-card-header">
          {{ 'REFDATA.PARTNERS.EDIT.SIGN_PICTURE' | translate }}
        </mat-card-header>
        <mat-card-content class="form-card-content">
          <app-media-upload [width]="150" [height]="200" [singleImage]="true" formControlName="signatureMedias"></app-media-upload>
        </mat-card-content>
      </mat-card>
    </div>

    <mat-card class="form-card">
      <mat-card-header class="form-card-header">
        {{ 'REFDATA.MARKETS' | translate }}
        <button class="mat-raised-button btn-submit mat-button-base" (click)="addMarket()">
          {{ 'REFDATA.PARTNERS.EDIT.NEW_MARKET' | translate }}
          <span class="fa fa-plus"></span>
        </button>
      </mat-card-header>
      <mat-card-content class="form-card-content">
        <mat-tab-group dynamicHeight class="client-tabs" *ngIf="form.controls.details.value" (selectedIndexChange)="changeTab($event)">
          <ng-container *ngFor="let detail of form.controls.details.value; let index = index">
            <mat-tab [label]="getLabelMarket(detail.market) + '/' + detail.lang">
              <div class="form-card-content">
                <button
                  class="space-h-s btn-cancel"
                  style="right: 15px; position: absolute"
                  mat-raised-button
                  (click)="deleteMarket(detail.market)"
                >
                  <span class="fa fa-trash"></span>
                </button>
                <mat-form-field class="mat-form-field form-field-l space-t-l" appearance="fill">
                  <mat-label>{{ 'REFDATA.PARTNERS.EDIT.NAME' | translate }}</mat-label>
                  <input matInput [(ngModel)]="detail.name" [ngModelOptions]="{ standalone: true }" required />
                  <mat-error>{{ 'REFDATA.PARTNERS.EDIT.NAME_REQUIRED' | translate }}</mat-error>
                </mat-form-field>

                <mat-form-field class="mat-form-field form-field-l" appearance="fill">
                  <mat-label>{{ 'REFDATA.PARTNERS.EDIT.DESCRIPTION' | translate }}</mat-label>
                  <textarea
                    matInput
                    [(ngModel)]="detail.description"
                    [ngModelOptions]="{ standalone: true }"
                    [required]="checkDescriptionError(detail.description)"
                  ></textarea>
                  <mat-error>{{ 'REFDATA.PARTNERS.EDIT.VISIBLE_STATUS_FIELD_REQUIRED' | translate }}</mat-error>
                </mat-form-field>

                <mat-form-field class="mat-form-field form-field-l" appearance="fill">
                  <mat-label>{{ 'REFDATA.PARTNERS.EDIT.WEBSITE_URL' | translate }}</mat-label>
                  <input matInput [(ngModel)]="detail.websiteUrl" [ngModelOptions]="{ standalone: true }" />
                </mat-form-field>
              </div>

              <mat-card class="form-card">
                <mat-card-header class="form-card-header">
                  {{ 'REFDATA.PARTNERS.EDIT.CROSS_SELLING_ZONE' | translate }}
                </mat-card-header>
                <mat-card-content class="form-card-content">
                  <mat-form-field class="mat-form-field form-field-l" appearance="fill">
                    <mat-label>{{ 'REFDATA.PARTNERS.EDIT.CROSS_SELLING_TITLE' | translate }}</mat-label>
                    <input matInput [(ngModel)]="detail.crossSellingTitle" [ngModelOptions]="{ standalone: true }" />
                  </mat-form-field>

                  <mat-form-field class="mat-form-field form-field-l" appearance="fill">
                    <mat-label>{{ 'REFDATA.PARTNERS.EDIT.CROSS_SELLING_DESCRIPTION' | translate }}</mat-label>
                    <textarea matInput [(ngModel)]="detail.crossSellingDescription" [ngModelOptions]="{ standalone: true }"></textarea>
                  </mat-form-field>

                  <mat-form-field class="mat-form-field form-field-l" appearance="fill">
                    <mat-label>{{ 'REFDATA.PARTNERS.EDIT.CALL_TO_ACTION_LABEL' | translate }}</mat-label>
                    <input matInput [(ngModel)]="detail.callToActionLabel" [ngModelOptions]="{ standalone: true }" />
                  </mat-form-field>

                  <mat-form-field class="mat-form-field form-field-l" appearance="fill">
                    <mat-label>{{ 'REFDATA.PARTNERS.EDIT.CALL_TO_ACTION_URL' | translate }}</mat-label>
                    <input matInput [(ngModel)]="detail.callToActionUrl" [ngModelOptions]="{ standalone: true }" />
                  </mat-form-field>

                  <p>
                    <mat-checkbox
                      style="margin-top: 10px; width: 20px"
                      [(ngModel)]="detail.isECommerce"
                      [ngModelOptions]="{ standalone: true }"
                    ></mat-checkbox>
                    {{ 'REFDATA.PARTNERS.EDIT.CALL_TO_ACTION_IS_ECOMMERCE' | translate }}
                  </p>
                </mat-card-content>
              </mat-card>

              <mat-card class="form-card">
                <mat-card-header class="form-card-header">
                  {{ 'REFDATA.PARTNERS.EDIT.RECIPES' | translate }} {{ getLabelMarket(detail.market) + '/' + detail.lang }}
                </mat-card-header>
                <mat-card-content class="form-card-content">
                  <app-list-recipe
                    [searchResult]="searchResult | async"
                    [domains]="(domains | async) || []"
                    [statusesRefData]="statusesRefData"
                    (pageChange)="handleSearchPage($event)"
                    (sortChange)="handleSearchSorted()"
                  ></app-list-recipe>
                </mat-card-content>
              </mat-card>
            </mat-tab>
          </ng-container>
        </mat-tab-group>
      </mat-card-content>
    </mat-card>
  </form>
</app-tpl-form>
